import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from './query';

/**
 * Tags of the shared api slice.
 *
 * They are namespaced on purpose: the per-domain slices each declared their own `List`,
 * and once everything lives in one api a bare `List` would mean "invalidate every list
 * in the application". Keep new tags in the `<Domain><Thing>` shape.
 */
export const ApiTags = {
  Asset: 'Asset',
  AssetList: 'AssetList',
  Document: 'Document',
  DocumentList: 'DocumentList',
  Organization: 'Organization',
  OrganizationList: 'OrganizationList',
  OrganizationDocumentList: 'OrganizationDocumentList',
  OrganizationInvite: 'OrganizationInvite',
  OrganizationInviteList: 'OrganizationInviteList',
  PaymentOptions: 'PaymentOptions',
  Poa: 'Poa',
  PoaList: 'PoaList',
  PoaUserList: 'PoaUserList',
  Profile: 'Profile',
  Staff: 'Staff',
  StaffList: 'StaffList',
  StaffInviteList: 'StaffInviteList',
  StaffPowers: 'StaffPowers',
  Dictionary: 'Dictionary',
} as const;

/**
 * Single api slice for the whole GraphQL domain.
 *
 * It starts empty: endpoints are added with `injectEndpoints` — by hand during the
 * migration and by graphql-codegen afterwards (see `codegen.ts`, `importBaseApiFrom`).
 * One slice means one cache, so a mutation in one domain can invalidate a query in
 * another — which eleven separate slices could not do.
 */
export const api = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: Object.values(ApiTags),
  endpoints: () => ({}),
});
